import React from "react";
import { CheckinStatus, CheckoutStatus } from "@/types/reservation";
import { PreCheckStatus } from "@/components/pages/settlement/types/settlementBooking";

const getGuestStatusLabel = (
  preCheckinStatus: PreCheckStatus | null | undefined,
  checkinStatus: CheckinStatus | null,
  preCheckoutStatus: PreCheckStatus | null | undefined,
  checkoutStatus?: CheckoutStatus | null,
) => {
  if (checkoutStatus === CheckoutStatus.DONE) {
    return "Checked out";
  }

  if (
    preCheckinStatus !== PreCheckStatus.DONE &&
    checkinStatus === CheckinStatus.NOT_DONE
  ) {
    return "Pre check-in";
  }

  if (
    checkinStatus === CheckinStatus.DONE &&
    preCheckoutStatus === PreCheckStatus.SENT &&
    checkoutStatus === CheckoutStatus.NOT_DONE
  ) {
    return "Pre check-out";
  }

  if (
    preCheckinStatus === PreCheckStatus.DONE &&
    checkinStatus === CheckinStatus.NOT_DONE
  ) {
    return "Before Check-in";
  }

  if (
    preCheckoutStatus === PreCheckStatus.DONE &&
    checkoutStatus === CheckoutStatus.NOT_DONE
  ) {
    return "Before Check-out";
  }

  if (checkinStatus === CheckinStatus.DONE) {
    return "In house";
  }

  return "Before Check-in";
};

export const GuestStatusCell = ({
  preCheckinStatus,
  checkinStatus,
  preCheckoutStatus,
  checkoutStatus,
}: {
  preCheckinStatus?: PreCheckStatus | null;
  checkinStatus: CheckinStatus | null;
  preCheckoutStatus?: PreCheckStatus | null;
  checkoutStatus?: CheckoutStatus | null;
}) => {
  const label = getGuestStatusLabel(
    preCheckinStatus,
    checkinStatus,
    preCheckoutStatus,
    checkoutStatus,
  );

  return <div className="text-sm text-center">{label}</div>;
};
